// import packages
import React, { Component } from "react";
import Slider from "react-slick";
import { connect } from "react-redux";

//Import styles
import "./mainSlider.scss";
import { ArrowLeft, ArrowRight } from "../../../assets/images";

// Import utils
import { generateImageMediaUrl, generateSliderMediaUrl } from "../../../utils/generateMediaUrl";
import { getPropsFromState } from "../../../redux/mapStateToProps";
import { ProgressBar } from "../../../components/progress-bar/Progress-Bar";
import {Link} from "react-router-dom";
import {getUrlWithLocal} from "../../../utils/getUrlWithLocal";

class MainSlider extends Component {
    constructor () {
        super();
        this.state = {
            slideIndex: 0,
            loadedImg: false,
            sliderCircleEnded: false,
        };
        this.handleImageLoaded = this.handleImageLoaded.bind(this);
    }

    getSliderIndex = (index) => {
        this.setState({
            slideIndex: index,
        });
        this.slider.slickGoTo(index);
    };

    nextSlide = (index) => {
        const { mainSlider } = this.props;
        this.setState({
            slideIndex: this.state.slideIndex - 1 === index ? 0 : index + 1,
        });
        if (mainSlider?.length - 1 === this.state.slideIndex) {
            this.setState({
                slideIndex: 0,
            });
        }
        this.slider.slickNext();
    };

    prevSlide = (index) => {
        const { mainSlider } = this.props;
        this.setState({
            slideIndex: index === 0 ? mainSlider?.length - 1 : index - 1,
        });
        this.slider.slickPrev();
    };

    handleImageLoaded (index) {
        console.log("index", index);
        console.log("!this.state.loadedImg)", !this.state.loadedImg);
        if (!this.state.loadedImg) {
            this.setState({ loadedImg: true });
        }
    }

    afterChangeSlideIndex = (slideIndex) => {
        this.setState({
            sliderCircleEnded: false,
        })
    };

    beforeChangeSlideIndex = (_, slideIndex) => {
        this.setState({
            slideIndex,
            sliderCircleEnded: true,
        })
    };

    render () {
        const { slideIndex, sliderCircleEnded} = this.state;
        const { mainSlider,staticTexts,settings} = this.props;
        // console.log(mainSlider,'mainSlider')
        const settings1 = {
            dots: false,
            arrows: false,
            infinite: true,
            autoplaySpeed: 3800,
            speed: 1000,
            autoplay: true,
            pauseOnHover: false,
            lazyLoad: 'progressive',
            swipeToSlide: true,
            swipe: true,
            ref: slider => (this.slider = slider),
            slidesToShow: 1,
            slidesToScroll: 1,
            afterChange: this.afterChangeSlideIndex,
            beforeChange: this.beforeChangeSlideIndex,
            fade: true,
        };


        return !!mainSlider && !!mainSlider.length && <div className="image-wrapper">
            <div className={'main-slider-items'}>
                {
                    slideIndex > 0 ? <div className={'slider-btn prev-btn'}
                                          onClick={() => this.prevSlide(slideIndex)}>
                        {'<'}
                    </div> : ''
                }
                <div className={'main-slider-inner-part'}>
                    <Slider {...settings1}>
                        {mainSlider?.length && mainSlider?.map((item, index) => {
                            const imagePath = window?.innerWidth > 600 ? item?.mediaMain?.path : (item?.responsiveMedia?.path ? item?.responsiveMedia?.path : item?.mediaMain?.path)
                            let title = item?.title
                            const firstIndex = title.indexOf('%s')
                            const lastIndex = title.lastIndexOf('%s')

                            if (firstIndex !== -1 && lastIndex !== -1 && firstIndex !== lastIndex) {
                                title = title.replace('%s', `${firstIndex === 0 ? "": '&nbsp;'}<span>`);
                                title = title.replace('%s', `</span>`);
                            }
                            return <div key={item.id} className={`slider-item`} ref={this.img}>
                                <img src={generateImageMediaUrl(imagePath)} alt={""}
                                     onLoad={() => this.handleImageLoaded(index)}/>
                                <div className={'slider-description'} dangerouslySetInnerHTML={{__html: title}}>
                                </div>
                                <div className={'slider_buttons'}>
                                    <a href={settings?.sliderUrl1} target={'_blank'} className={'green_button'}>{staticTexts?.main_slider_green_btn || 'Выбрать таунхаус'}</a>
                                    <a href={settings?.sliderUrl2} target={'_blank'} className={'white_button'}>{staticTexts?.main_slider_white_btn || 'Подробнее'}</a>
                                </div>
                            </div>
                        })}
                    </Slider>
                </div>
                {
                    mainSlider?.length > 1 ? <div className={'slider-btn next-btn'}
                                                   onClick={() => this.nextSlide(slideIndex)}>
                        >
                    </div> : ''
                }
                <div className={'bar-wrapper'}>
                    <ProgressBar slideIndex={slideIndex}
                                 sliderCircleEnded={sliderCircleEnded}
                                 sliderLenght={mainSlider?.length}
                                 slider={mainSlider}
                    />
                </div>
            </div>
        </div>
    }
}


const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'mainSlider',
        'contact',
        'settings',
    ])
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MainSlider);
